import { schema } from "normalizr";
export const application = new schema.Entity("application");
export const applicationsSchema = new schema.Entity("applications", {
  applications: [application]
}, {
  idAttribute: "applicationId"
});
export const document = new schema.Entity("document");
export const documentSchema = new schema.Entity("documents", {
  documents: [document]
}, {
  idAttribute: "documentId"
});
export const clientApplicationRequest = new schema.Entity("clientApplicationRequest");
export const clientApplicationRequestSchema = new schema.Entity("clientApplicationRequests", {
  clientApplicationRequests: [clientApplicationRequest]
}, {
  idAttribute: "clientApplicationRequestId"
});
export const filogixSubmission = new schema.Entity("filogixSubmission");
export const filogixSubmissionSchema = new schema.Entity("filogixSubmissions", {
  filogixSubmissions: [filogixSubmission]
}, {
  idAttribute: "filogixSubmissionId"
});
export const eSignTemplate = new schema.Entity("eSignTemplate");
export const eSignTemplatesSchema = new schema.Entity("eSignTemplates", {
  eSignTemplates: [eSignTemplate]
}, {
  idAttribute: "eSignTemplateId"
});
export const requestedPackage = new schema.Entity("requestedPackage");
export const requestedPackagesSchema = new schema.Entity("requestedPackages", {
  requestedPackages: [requestedPackage]
}, {
  idAttribute: "requestId"
});